const ErrorParser = {
  asMessage: function (error) {
    let message = "Unknown error";
    if (error.response) {
      if (error.response.status === 400) {
        let errMsg = error.response.data && error.response.data.error && error.response.data.error.message;
        if (!errMsg) errMsg = error.response.data && error.response.data.error;
        message = JSON.stringify(errMsg);
      } else {
        message = error.response.data && error.response.data.error || "An error occurred";
      }
    } else if (error.message) {
      // Handle cases where error.response is undefined
      message = error.message;
    }
    return message;
  }
};

export default ErrorParser;